import { render } from "./LogoSVG.vue?vue&type=template&id=48f724fb"
const script = {}
script.render = render

export default script